export default __webpack_public_path__ + "static/media/tot.e4edb439.svg";